"use client";

import { getActiveDecorationSet } from "@/lib/utils/decorations";
import { getDecorationSet } from "./registry";

/**
 * ActiveDecorations
 *
 * Renders the active background decorations based on NEXT_PUBLIC_ACTIVE_DECORATIONS.
 * Returns null if no decorations are enabled or if the active set has no background component.
 *
 * @example
 * ```tsx
 * <ActiveDecorations />
 * ```
 */
export function ActiveDecorations() {
  try {
    const activeSet = getActiveDecorationSet();

    if (!activeSet) {
      return null;
    }

    const decorationSet = getDecorationSet(activeSet);

    if (!decorationSet || !decorationSet.background) {
      return null;
    }

    const BackgroundComponent = decorationSet.background;
    return <BackgroundComponent />;
  } catch (error) {
    // Log error in development, fail silently in production
    if (process.env.NODE_ENV === "development") {
      console.error("[Decorations] Error rendering background decorations:", error);
    }
    return null;
  }
}
